import './public-path';
import './scripts/browser-support';
import './scripts/analytics';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import { notification } from 'antd';
import { Config } from './scripts/config';
import { Localization } from './src/Localization';
import { apis } from "@vote4dance/judging-sdk";
var Connection = apis.connections.Connection;
var Session = apis.sessions.Session;
export class ReactAppMain {
    initialize() {
        this._internalInitialize()
            .then(this.onCreated)
            .catch((err) => {
            notification.error({
                message: "Failed to initialize application",
                description: err.message,
                onClick() {
                    alert(err.toString());
                }
            });
        });
    }
    async _internalInitialize() {
        const apiUrl = Config.get('api_url');
        this.removeHashFromLocation();
        await Localization.init(this.getLocales());
        await Connection.get().initialize(apiUrl);
        await Session.get().initialize();
    }
    getLocales() {
        return {};
    }
    onCreated() { }
    removeHashFromLocation() {
        if (window.location.hash) {
            const cleanUrl = window.location.href.split('#')[0] + window.location.hash.slice(1);
            window.history.replaceState(null, '', cleanUrl);
        }
    }
}
